// Landing page is served as pure HTML from public/index.html
// React renders nothing so the static HTML is the only visible content.
function App() {
  return null;
}

export default App;
